import { render, staticRenderFns } from "./GHGIBar.vue?vue&type=template&id=1a898a3d"
import script from "./GHGIBar.vue?vue&type=script&lang=js"
export * from "./GHGIBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports